import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { ErrorIcon } from '@woovi/ui';

import type { PaymentExpired_charge$key } from './__generated__/PaymentExpired_charge.graphql.ts';
import PaymentLinkExpiredValue from './paymentLinkExpired/PaymentLinkExpiredValue.tsx';
import PaymentLinkAdditionalInfo from '../paymentLink/PaymentLinkAdditionalInfo.tsx';
import PaymentMethodTransactionDetails from '../paymentMethod/PaymentMethodTransactionDetails.tsx';

type PaymentExpiredProps = {
  charge: PaymentExpired_charge$key;
};

const PaymentExpired = (props: PaymentExpiredProps): ReactNode => {
  const theme = useTheme();
  const { t } = useTranslation();
  const charge = useFragment<PaymentExpired_charge$key>(
    graphql`
      fragment PaymentExpired_charge on Charge {
        identifier
        company {
          nameFriendly
          taxID {
            taxID
          }
        }
        ...PaymentLinkExpiredValue_charge
        ...PaymentLinkAdditionalInfo_charge
        ...PaymentMethodTransactionDetails_charge
      }
    `,
    props.charge,
  );

  return (
    <Stack sx={{ gap: 1, alignItems: 'center' }}>
      <ErrorIcon />
      <Stack sx={{ gap: 0.5 }}>
        <Typography variant='h4' fontWeight='bold' textAlign='center' sx={{}}>
          {t('Charge expired')}
        </Typography>
        <Typography
          variant='h6'
          textAlign='center'
          sx={{
            color: theme.palette.text.secondary,
          }}
        >
          {t('The payment period for this charge has expired.')}
        </Typography>
      </Stack>
      <PaymentLinkExpiredValue charge={charge} />
      <PaymentMethodTransactionDetails charge={charge} />
      <PaymentLinkAdditionalInfo charge={charge} />
    </Stack>
  );
};

export default PaymentExpired;
